import DialogAlert from './DialogAlert'

export default DialogAlert
